import * as Yup from 'yup'

export default Yup.object().shape({
    applicationServiceId: Yup.number().typeError('Aplicação é obrigatório!').required('Aplicação é obrigatório!')
})